module.exports = __webpack_public_path__ + "ecb3243f1c1b2bb0cf3de3fe06598457.svg";